/**
 * Date range utilities for the dashboard.
 */

import { DateRange, DateRangePreset } from './types';

/**
 * Convert a date range preset to actual Date objects.
 */
export const getDateRangeFromPreset = (preset: DateRangePreset): DateRange => {
  const now = new Date();
  const to = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59,
    999
  );

  switch (preset) {
    case 'this-month': {
      const from = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
      return { from, to };
    }
    case 'last-month': {
      const from = new Date(
        now.getFullYear(),
        now.getMonth() - 1,
        1,
        0,
        0,
        0,
        0
      );
      const lastDayOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
      const to = new Date(
        lastDayOfLastMonth.getFullYear(),
        lastDayOfLastMonth.getMonth(),
        lastDayOfLastMonth.getDate(),
        23,
        59,
        59,
        999
      );
      return { from, to };
    }
    case 'last-3-months': {
      const from = new Date(now);
      from.setMonth(from.getMonth() - 3);
      from.setHours(0, 0, 0, 0);
      return { from, to };
    }
    case 'last-6-months': {
      const from = new Date(now);
      from.setMonth(from.getMonth() - 6);
      from.setHours(0, 0, 0, 0);
      return { from, to };
    }
    case 'last-12-months': {
      const from = new Date(now);
      from.setFullYear(from.getFullYear() - 1);
      from.setHours(0, 0, 0, 0);
      return { from, to };
    }
    case 'all-time':
      return {};
  }
};

/** Get the locale for a region */
const getLocaleForRegion = (region?: string): string => {
  return region === 'US' ? 'en-US' : 'en-GB';
};

/**
 * Generate date labels for the last N days.
 */
export const getDateLabels = (days: number, region?: string): string[] => {
  const labels: string[] = [];
  const now = new Date();
  const locale = getLocaleForRegion(region);

  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    labels.push(
      date.toLocaleDateString(locale, { day: 'numeric', month: 'short' })
    );
  }
  return labels;
};
